import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Home } from "./components/Home";
import Dashboard from "./components/Dashboard";
import { JoinGame } from "./components/JoinGame";
import { CompanyInfo } from "./components/CompanyInfo";
import { CollectedCards } from "./mobilePages/CollectedCards";
import { AllPlayerHoldings } from "./mobilePages/AllPlayerHoldings";
import { AllTrades } from "./mobilePages/AllTrades";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { AndroidAppPopup } from "./components/AndroidAppPopup";

function App() {
  if (window.location.protocol === "http:" && window.location.hostname !== "localhost") {
    window.location.href = window.location.href.replace("http:", "https:");
  }

  if (!localStorage.getItem("token")) {
    return (
      <Router>
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Router>
    )
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/game/:gameId" element={<Dashboard />} />
        <Route path="/join/:gameId" element={<JoinGame />} />
        <Route path="/company/:companyId" element={<CompanyInfo />} />
        <Route path="/collected-cards" element={<CollectedCards />} />
        <Route path="/all-player-holdings" element={<AllPlayerHoldings />} />
        <Route path="/all-trades" element={<AllTrades />} />
        <Route path="/android-device-onboarding" element={<AndroidAppPopup />} />
      </Routes>
    </Router>
  );
}

export default App;
